module.exports = __webpack_public_path__ + "img/logo-so-energy-black.de708a2.svg";